import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = {
  key: 1,
  class: "t"
}
const _hoisted_6 = { class: "form" }
const _hoisted_7 = {
  key: 1,
  class: "sendTime"
}
const _hoisted_8 = { class: "server" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "l-img" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.windowW > 850)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "t",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchLogin && _ctx.switchLogin(...args)))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "t1" }, "已有帐号，", -1),
                _createElementVNode("span", { class: "t2" }, "马上登录", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("span", { class: "t1" }, "已有帐号，", -1),
                _createElementVNode("a", {
                  class: "t2",
                  href: "login"
                }, "马上登录", -1)
              ]))])),
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeName,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeName) = $event)),
            class: "e-tabs",
            onTabClick: _ctx.handleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "注册",
                name: "register"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_form, {
                      ref: "ruleFormRef",
                      model: _ctx.ruleForm,
                      rules: _ctx.rules,
                      class: "demo-ruleForm mt20"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "+86",
                          prop: "mobile",
                          class: "numItem"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.mobile,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mobile) = $event)),
                              placeholder: "请输入手机号",
                              class: "el-int",
                              maxlength: "11",
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "code",
                          class: "mt20"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.code,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
                              class: "el-int code register-code",
                              autocomplete: "off",
                              maxlength: "6"
                            }, null, 8, ["modelValue"]),
                            (_ctx.isShowSend)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  class: "send",
                                  style: {"color":"#000"},
                                  onClick: _ctx.send
                                }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("发送验证码", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (!_ctx.isShowSend)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.timeNum) + "S重新发送 ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "输入密码",
                          class: "mt20",
                          prop: "password"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.password,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                              placeholder: "请输入密码",
                              class: "el-int",
                              type: "password",
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "确认密码",
                          class: "mt20",
                          prop: "password_confirmation",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.password_confirmation,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password_confirmation) = $event)),
                              placeholder: "请再次输入密码",
                              class: "el-int",
                              type: "password"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          class: _normalizeClass(_ctx.isAffirm ? 'register-btn isAffirm' : 'register-btn'),
                          disabled: !_ctx.isAffirm,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit(_ctx.ruleFormRef)))
                        }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("注册", -1)
                          ]))]),
                          _: 1
                        }, 8, ["class", "disabled"]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.server,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.server) = $event)),
                            size: "large",
                            class: "checkbox"
                          }, null, 8, ["modelValue"]),
                          _cache[14] || (_cache[14] = _createTextVNode(" 我已阅读并同意知鸦 ", -1)),
                          _createVNode(_component_router_link, { to: "/serviceAgree" }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("《用户协议》", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[15] || (_cache[15] = _createTextVNode("和", -1)),
                          _createVNode(_component_router_link, { to: "/intimityPolicy" }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode("《隐私政策》", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onTabClick"])
        ])
      ])
    ])
  ]))
}